import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { useLocation } from "react-router-dom";

class ErrorBoundaryInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary:", error, info);
  }
  componentDidUpdate(prevProps) {
    // Auto-reset when the user navigates away from the broken route.
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false, error: null });
    }
  }
  reset = () => this.setState({ hasError: false, error: null });
  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6" data-testid="error-boundary">
          <div className="border border-red-300 bg-red-50 p-4">
            <div className="flex items-center gap-2 mb-2">
              <AlertTriangle size={16} className="text-red-600" />
              <div className="text-sm font-black uppercase tracking-widest text-red-700">
                Se produjo un error en esta vista
              </div>
            </div>
            <div className="text-xs text-red-800 mb-3 font-mono whitespace-pre-wrap">
              {String(this.state.error?.message || this.state.error || "Error desconocido")}
            </div>
            <div className="text-[11px] text-red-700 mb-3">
              La aplicación no perderá tu sesión. Puedes reintentar o navegar a otra sección — al cambiar de ruta este error se limpia automáticamente.
            </div>
            <button
              onClick={this.reset}
              className="inline-flex items-center gap-1 border border-red-300 bg-white px-3 h-8 text-xs font-bold hover:bg-red-100"
              data-testid="error-boundary-retry"
            >
              <RefreshCw size={12} /> Reintentar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export function ErrorBoundary({ children }) {
  const location = useLocation();
  return <ErrorBoundaryInner resetKey={location.pathname}>{children}</ErrorBoundaryInner>;
}
